<div class="modal-header text-center" style="border-bottom: none">
  @if (title) {
    <h4 [innerHTML]="title"></h4>
  }
  <p [innerHTML]="message"></p>
</div>
<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    {{ cancelLabel }}
  </div>
  <div
    class="btn pull-right"
    [ngClass]="confirmButtonClass"
    aria-label="Confirm"
    (click)="confirm()"
  >
    {{ confirmLabel }}
  </div>
</div>
